import React from 'react';

import { Tooltip } from 'antd';
import useClipboard from 'react-use-clipboard';
import { withTheme } from 'styled-components';

import CopyIcon from './icons/CopyIcon';
import CopyRoundIcon from './icons/CopyRoundIcon';

interface CopyToClipboardProps {
  data: string;
  theme: any;
  round?: boolean;
}
const CopyToClipboard = (props: CopyToClipboardProps) => {
  const [isCopied, setCopied] = useClipboard(props.data, {
    successDuration: 1000,
  });

  return !props.round ? (
    <Tooltip
      title={isCopied ? 'Copied !' : 'Copy'}
      open={isCopied ? true : undefined}
    >
      <CopyIcon onClick={setCopied} isCopied={isCopied} />
    </Tooltip>
  ) : (
    <Tooltip
      title={isCopied ? 'Copied !' : 'Copy'}
      open={isCopied ? true : undefined}
    >
      <CopyRoundIcon onClick={setCopied} isCopied={isCopied} />
    </Tooltip>
  );
};

export default withTheme(CopyToClipboard);
